import { LazyLoad } from '@petconsole/pure-fe-mui';

const PclHeader = LazyLoad(() => import('./PclHeaderApp'));
const PclHeaders = LazyLoad(() => import('./PclHeadersApp'));

export { PclHeader, PclHeaders };
